<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <h5 class="text-center">English Section</h5>
      <div class="row">
        <div class="col-md-12 col-sm-12">

          <div class="row">
            <div class="col-md-12">
              <fg-select
                name="focus_area_id"
                size="large"
                filterable
                clearable
                placeholder="Select Focus Area"
                :input-classes="'select-default'"
                :label="'Focus Area'"
                :list="builderData.focusAreaList"
                :listItemLabel="'title'"
                :listItemValue="'id'"
                v-model="formData.focus_area_id">
              </fg-select>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <ValidationProvider
                vid="title"
                rules="required"
                name="The Title"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="title"
                          name="title"
                          fou
                          @keyup="generateSomeFields"
                          v-model="formData.title">
                </fg-input>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider
                vid="url"
                rules="required"
                name="The URL"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="URL"
                          name="url"
                          fou
                          v-model="formData.url">
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider
                vid="sub_title"
                rules="required"
                name="The Sub Title"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="Sub Title"
                          name="sub_title"
                          fou
                          v-model="formData.sub_title">
                </fg-input>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <fg-select
                name="status"
                size="large"
                filterable
                clearable
                placeholder="Select Status"
                :input-classes="'select-default'"
                :label="'Status'"
                :list="builderData.statusList"
                :listItemLabel="'label'"
                :listItemValue="'value'"
                v-model="formData.status">
              </fg-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <fg-select
                name="blogs"
                size="large"
                filterable
                clearable
                placeholder="Select Blog"
                :input-classes="'select-default'"
                :label="'Blog'"
                :list="builderData.blogList"
                :listItemLabel="'title'"
                :listItemValue="'id'"
                v-model="formData.blog_id">
              </fg-select>
            </div>
          </div>
          <!-- Linked News Section -->
          <div class="team_list_items">
            <label class="section_name">Linked News</label>
            <div class="row">
              <div class="col-md-12">
                <fg-select
                  name="news"
                  size="large"
                  filterable
                  clearable
                  multiple
                  placeholder="Select News Items"
                  :input-classes="'select-default'"
                  :label="'Add News Items'"
                  :list="builderData.newsList"
                  :listItemLabel="'title'"
                  :listItemValue="'id'"
                  v-model="formData.news">
                </fg-select>
              </div>
            </div>
            
            <!-- Display currently linked news -->
            <div v-if="linkedNewsList.length > 0" class="row mt-3">
              <div class="col-md-12">
                <label>Currently Linked News Items ({{ linkedNewsList.length }})</label>
                <div class="linked-items-container">
                  <div v-for="newsItem in linkedNewsList" :key="newsItem.id" class="linked-item-card">
                    <div class="linked-item-content">
                      <h6>{{ newsItem.title }}</h6>
                      <small class="text-muted">{{ newsItem.type ? newsItem.type.name : 'No Type' }}</small>
                    </div>
                    <div class="linked-item-actions">
                      <l-button
                        @click="removeLinkedNews(newsItem.id)"
                        type="danger" 
                        size="sm"
                        class="btn-simple">
                        <i class="fa fa-times"></i>
                      </l-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div v-else class="row mt-3">
              <div class="col-md-12">
                <p class="text-muted">No news items linked to this initiative yet.</p>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Image</label>
            <el-tooltip placement="right" >
              <div slot="content"> (548 * 548)</div>
              <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
            </el-tooltip>
            <single-file-uploader-file-manager
              :preview-width="'200px'"
              :preview-height="'200px'"
              v-model="formData.image"
              :accepted-files="imagesExtensions">
            </single-file-uploader-file-manager>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-12">
                <ValidationProvider
                  vid="content_title"
                  rules=""
                  name="The Content Title"
                  v-slot="{ passed, failed,errors }">
                  <fg-input type="text"
                            :error="failed ? errors[0]: null"
                            label="Content Title"
                            name="content_title"
                            fou
                            v-model="formData.content_title">
                  </fg-input>
                </ValidationProvider>
              </div>
            </div>
            <label>Content</label>
            <editor
              v-model="formData.content"
              :api-key="editorKey"
              :init='editorConfig'
            />
          </div>
          <div class="col-md-12 com-sm-12 mb-2 mt-2">
            <div class="row d-flex justify-content-between">
              <div class="list-items">
                <label>Goals</label>
                <div class="col-12">
                  <template class="row" v-for="(goal,goalIndex) in formData.goals">
                    <fg-input type="text"
                              :label="'Goal '+(goalIndex+1)"
                              v-model="formData.goals[goalIndex]">
                    </fg-input>
                    <div class="col-sm-1 align-self-center mt-3">
                      <l-button
                        @click="removeGoal(formData.goals, goalIndex)"
                        type="danger" size="sm">
                        <i class="fa fa-trash"></i>
                      </l-button>
                    </div>
                  </template>
                  <l-button
                    class="mt-3"
                    type="success"
                    @click="addNewGoal(formData.goals)"
                    size="sm">
                    <i class="fa fa-plus"></i>
                  </l-button>
                </div>
              </div>
              <div class="list-items">
                <label>Courses</label>
                <div class="col-12">
                  <template class="row" v-for="(course,courseIndex) in formData.courses">
                    <fg-input type="text"
                              :label="'Course '+(courseIndex+1)"
                              v-model="formData.courses[courseIndex]">
                    </fg-input>
                    <div class="col-sm-1 align-self-center mt-3">
                      <l-button
                        @click="removeGoal(formData.courses, courseIndex)"
                        type="danger" size="sm">
                        <i class="fa fa-trash"></i>
                      </l-button>
                    </div>
                  </template>
                  <l-button
                    class="mt-3"
                    type="success"
                    @click="addNewGoal(formData.courses)"
                    size="sm">
                    <i class="fa fa-plus"></i>
                  </l-button>
                </div>
              </div>
              <div class="list-items">
                <label>Milestones</label>
                <div class="col-12">
                  <ValidationProvider
                    vid="milestones"
                    rules=""
                    name="The Milestones Title"
                    v-slot="{ passed, failed,errors }">
                    <fg-input type="text"
                              :error="failed ? errors[0]: null"
                              label="Milestones Title"
                              name="milestones"
                              fou
                              v-model="formData.milestones_title">
                    </fg-input>
                  </ValidationProvider>
                  <template class="row" v-for="(milestone, milestoneIndex) in formData.milestones">
                    <div class="col-md-10">
                      <fg-input type="text"
                                :key="milestoneIndex"
                                :label="'Milestone '+(milestoneIndex+1)"
                                v-model="formData.milestones[milestoneIndex].title">
                      </fg-input>
                    </div>
                    <div class="col-md-10">
                      <label class="card-label">Date</label>
                      <fg-input v-model="formData.milestones[milestoneIndex].date"
                                value-format="YYYY-MM-DD HH:MM:SS"
                                type="datetime-local"
                                placeholder="Chose milestone date"
                      >
                      </fg-input>
                    </div>
                    <div class="col-sm-1 align-self-center mt-3">
                      <l-button
                        @click="removeMilestone(formData.milestones, milestoneIndex)"
                        type="danger" size="sm">
                        <i class="fa fa-trash"></i>
                      </l-button>
                    </div>
                  </template>
                  <l-button
                    class="mt-3"
                    type="success"
                    @click="addNewMilestone(formData.milestones, {title: '', date: ''})"
                    size="sm">
                    <i class="fa fa-plus"></i>
                  </l-button>
                </div>
              </div>
              <div class="list-items">
                <label>Public Comments</label>
                <div class="col-12">
                  <template class="row" v-for="(item, itemIndex) in formData.public_comments">
                    <div class="col-md-10">
                      <fg-input type="text"
                                :key="itemIndex"
                                :label="'Text '+(itemIndex+1)"
                                v-model="formData.public_comments[itemIndex].title">
                      </fg-input>
                    </div>
                    <div class="col-md-10">
                      <label class="card-label">Content</label>
                      <editor
                        v-model="formData.public_comments[itemIndex].content"
                        :api-key="editorKey"
                        :init='editorConfig'
                      />
                    </div>
                    <div class="col-sm-1 align-self-center mt-3">
                      <l-button
                        @click="removePublicComments(formData.public_comments, itemIndex)"
                        type="danger" size="sm">
                        <i class="fa fa-trash"></i>
                      </l-button>
                    </div>
                  </template>
                  <l-button
                    class="mt-3"
                    type="success"
                    @click="addNewPublicComments(formData.public_comments, {title: '', content: ''})"
                    size="sm">
                    <i class="fa fa-plus"></i>
                  </l-button>
                </div>
              </div>
            </div>
            <div class="row">
            <div class="col-md-12">
              <fg-select
                name="partners"
                size="large"
                filterable
                clearable
                multiple
                placeholder="Select Partners"
                :input-classes="'select-default'"
                :label="'Partners'"
                :list="builderData.partnersList"
                :listItemLabel="'name'"
                :listItemValue="'id'"
                v-model="formData.partners">
              </fg-select>
            </div>
          </div>
          </div>
          <label>Achievement</label>
          <editor
            v-model="formData.achievement"
            :api-key="editorKey"
            :init='editorConfig'
          />
          <div class="row" style="margin-top: 25px;">
            <div class="col-md-12">
              <ValidationProvider
                vid="gallery_title"
                rules=""
                name="The Gallery Title"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="Gallery Title"
                          name="gallery_title"
                          fou
                          v-model="formData.gallery_title">
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group">
            <label>Gallery</label>
            <el-tooltip placement="right" v-if="false">
              <div slot="content"></div>
              <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
            </el-tooltip>
            <multiple-file-uploader-file-manager
              :preview-width="'200px'"
              :preview-height="'200px'"
              v-model="formData.gallery"
              :files-number="30"
              :accepted-files="imagesExtensions">
            </multiple-file-uploader-file-manager>
          </div>
          <!-- // -->
          <div class="form-group">
            <label>PDF</label>
            <el-tooltip placement="right" v-if="false">
              <div slot="content"></div>
              <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
            </el-tooltip>
            <multiple-file-uploader-file-manager
              :preview-width="'200px'"
              :preview-height="'200px'"
              v-model="formData.files"
              :files-number="30"
              :fileType="'document'"
              :accepted-files="pdfExtensions">
            </multiple-file-uploader-file-manager
>
          </div>

          <div class="form-group" >
            <label>Videos</label>
            <el-tooltip placement="right" v-if="false">
              <div slot="content"></div>
              <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
            </el-tooltip>
            <multiple-file-uploader-file-manager  :preview-width="'200px'"
                                                :preview-height="'200px'"
                                                v-model="formData.videos"
                                                :files-number="30"
                                                :accepted-files="videosExtensions">

            </multiple-file-uploader-file-manager>
          </div>

<!--          //Links-->
          <div class="row">
            <div class="col-md-12">
              <label>Links</label>
              <div class="col-12">
                <template class="row" v-for="(listItem,listItemIndex) in formData.links">
                  <div class="row team_list_items">
                    <label>Item # {{ listItemIndex + 1 }}</label>
                    <!--                list item title-->
                    <div class="col-md-12">
                      <ValidationProvider
                        :vid="'link_title_' + listItemIndex"
                        rules="required"
                        name="The Title"
                        v-slot="{ passed, failed,errors }">
                        <fg-input type="text"
                                  :key="'title_'+listItemIndex"
                                  :error="failed ? errors[0]: null"
                                  :label="'Title '+(listItemIndex+1)"
                                  v-model="formData.links[listItemIndex].title">
                        </fg-input>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-12">
                      <ValidationProvider
                        :vid="'link_type_' + listItemIndex"
                        rules="required"
                        name="The Type"
                        v-slot="{ passed, failed,errors }">
                        <fg-select
                          name="linkstype"
                          size="large"
                          filterable
                          clearable
                          placeholder="Type"
                          :error="failed ? errors[0]: null"
                          :input-classes="'select-default'"
                          :label="'Type'"
                          :list="builderData.initiativeLinksType"
                          :listItemLabel="'label'"
                          :listItemValue="'value'"
                          v-model="formData.links[listItemIndex].type">
                        </fg-select>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-12">
                      <ValidationProvider
                        :vid="'link_url_' + listItemIndex"
                        rules="required"
                        name="The Link"
                        v-slot="{ passed, failed,errors }">
                        <fg-input type="text"
                                  :key="'link_'+listItemIndex"
                                  :error="failed ? errors[0]: null"
                                  :label="'Link '+(listItemIndex+1)"
                                  v-model="formData.links[listItemIndex].link">
                        </fg-input>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-sm-1 align-self-center mt-3">
                    <l-button
                      @click="removeItem(formData.links, listItemIndex)"
                      type="danger" size="sm">
                      <i class="fa fa-trash"></i>
                    </l-button>
                  </div>
                </template>
                <l-button
                  class="mt-3"
                  type="success"
                  @click="addNewItem(formData.links, { title: '', type: '', link: ''})"
                  size="sm">
                  <i class="fa fa-plus"></i>
                </l-button>
              </div>
            </div>
          </div>
          <!-- /// -->


<!--          //join section-->
  <div class="team_list_items">
    <label class="section_name">Join Section</label>
    <div class="row">
      <div class="col-md-6">
        <ValidationProvider
          vid="join_title"
          rules=""
          name="The Join Title"
          v-slot="{ passed, failed,errors }">
          <fg-input type="text"
                    :error="failed ? errors[0]: null"
                    label="Join Title"
                    name="join_title"
                    fou
                    v-model="formData.join_title">
          </fg-input>
        </ValidationProvider>
      </div>
      <div class="col-md-6">
        <ValidationProvider
          vid="join_link"
          rules=""
          name="The Join Link"
          v-slot="{ passed, failed,errors }">
          <fg-input type="text"
                    :error="failed ? errors[0]: null"
                    label="Join Link"
                    name="join_link"
                    fou
                    v-model="formData.join_link">
          </fg-input>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-group">
      <label>Join Content</label>
      <editor
        v-model="formData.join_content"
        :api-key="editorKey"
        :init='editorConfig'
      />
    </div>
    <!-- //extra sections  -->

    <div class="row">
            <div class="col-md-12">
              <label>Extra Sections</label>
              <div class="col-12">
                <template class="row" v-for="(listItem,listItemIndex) in formData.join_extra_sections">
                  <div class="row team_list_items">
                    <label>Item # {{ listItemIndex + 1 }}</label>
                    <!--                list item title-->
                    <div class="col-md-12">
                      <ValidationProvider
                        :vid="'extra_section_title_' + listItemIndex"
                        rules="required"
                        name="The Title"
                        v-slot="{ passed, failed,errors }">
                        <fg-input type="text"
                                  :key="'title_'+listItemIndex"
                                  :error="failed ? errors[0]: null"
                                  :label="'Title '+(listItemIndex+1)"
                                  v-model="formData.join_extra_sections[listItemIndex].title">
                        </fg-input>
                      </ValidationProvider>
                    </div>

                    <div class="form-group">
                    <label>Content {{(listItemIndex+1)}}</label>
                    <editor
                      v-model="formData.join_extra_sections[listItemIndex].content"
                      :api-key="editorKey"
                      :init='editorConfig'
                    />
                    </div>

                  </div>
                  <div class="col-sm-1 align-self-center mt-3">
                    <l-button
                      @click="removeItem(formData.join_extra_sections, listItemIndex)"
                      type="danger" size="sm">
                      <i class="fa fa-trash"></i>
                    </l-button>
                  </div>
                </template>
                <l-button
                  class="mt-3"
                  type="success"
                  @click="addNewItem(formData.join_extra_sections, { title: '', content: ''})"
                  size="sm">
                  <i class="fa fa-plus"></i>
                </l-button>
              </div>
            </div>
          </div>

    <!-- //end extra sections  -->
  </div>


        <div class="form-group pt-4">
          <label>Extra Info</label>
          <editor
            v-model="formData.extra_info"
            :api-key="editorKey"
            :init='editorConfig'
          />
        </div>

          <!--          //Final Report-->
          <div class="team_list_items">
            <label class="section_name">Final Report</label>
            <div class="row">
              <div class="col-md-12">
                <ValidationProvider
                  vid="final_report_main_title"
                  rules=""
                  name="The Final Report Main Title"
                  v-slot="{ passed, failed,errors }">
                  <fg-input type="text"
                            :error="failed ? errors[0]: null"
                            label="Final Report Main Title"
                            name="final_report_main_title"
                            fou
                            v-model="formData.final_report_main_title">
                  </fg-input>
                </ValidationProvider>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ValidationProvider
                  vid="final_report_title"
                  rules=""
                  name="The Final Report Title"
                  v-slot="{ passed, failed,errors }">
                  <fg-input type="text"
                            :error="failed ? errors[0]: null"
                            label="Final Report Title"
                            name="final_report_title"
                            fou
                            v-model="formData.final_report_title">
                  </fg-input>
                </ValidationProvider>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="card-label">Final Report Date</label>
                <fg-input v-model="formData.final_report_date"
                          value-format="YYYY-MM-DD HH:MM:SS"
                          type="datetime-local"
                          placeholder="Chose milestone date"
                >
                </fg-input>
              </div>
            </div>

            <div class="form-group">
              <label>Final Report Content</label>
              <editor
                v-model="formData.final_report_content"
                :api-key="editorKey"
                :init='editorConfig'
              />
            </div>
            <div class="form-group">
              <label>Final Report Image</label>
              <el-tooltip placement="right" >
                <div slot="content"> (548 * 548)</div>
                <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
              </el-tooltip>
              <single-file-uploader-file-manager
                :preview-width="'200px'"
                :preview-height="'200px'"
                v-model="formData.final_report_image"
                :accepted-files="imagesExtensions">
              </single-file-uploader-file-manager>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Final Report PDF</label>
                  <el-tooltip placement="right" >
                    <div slot="content"> (548 * 548)</div>
                    <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
                  </el-tooltip>
                  <single-file-uploader-file-manager
                    :preview-width="'200px'"
                    :preview-height="'200px'"
                    v-model="formData.final_report_link"
                    :fileType="'document'"
                    :accepted-files="pdfExtensions">
                  </single-file-uploader-file-manager>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Final Report Executive Summary</label>
                  <el-tooltip placement="right" >
                    <div slot="content"> (548 * 548)</div>
                    <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
                  </el-tooltip>
                  <single-file-uploader-file-manager
                    :preview-width="'200px'"
                    :preview-height="'200px'"
                    v-model="formData.final_report_executive_summary"
                    :fileType="'document'"
                    :accepted-files="pdfExtensions">
                  </single-file-uploader-file-manager>
                </div>
              </div>
            </div>
            <!--          //Keywords-->
            <div class="row">
              <div class="col-md-12">
                <label>Keywords</label>
                <div class="col-12">
                  <template class="row" v-for="(listItem,listItemIndex) in formData.final_report_keywords">
                    <div class="row team_list_items">
                      <label>Item # {{ listItemIndex + 1 }}</label>
                      <!--                list item title-->
                      <div class="col-md-12">
                        <ValidationProvider
                          :vid="'keyword_title_' + listItemIndex"
                          rules="required"
                          name="The Title"
                          v-slot="{ passed, failed,errors }">
                          <fg-input type="text"
                                    :key="'title_'+listItemIndex"
                                    :error="failed ? errors[0]: null"
                                    :label="'Title '+(listItemIndex+1)"
                                    v-model="formData.final_report_keywords[listItemIndex].title">
                          </fg-input>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="col-sm-1 align-self-center mt-3">
                      <l-button
                        @click="removeItem(formData.final_report_keywords, listItemIndex)"
                        type="danger" size="sm">
                        <i class="fa fa-trash"></i>
                      </l-button>
                    </div>
                  </template>
                  <l-button
                    class="mt-3"
                    type="success"
                    @click="addNewItem(formData.final_report_keywords, { title: ''})"
                    size="sm">
                    <i class="fa fa-plus"></i>
                  </l-button>
                </div>
              </div>
            </div>
            <!-- /// -->
          </div>

          <div class="d-flex justify-content-between">
            <!--          //is active-->
            <div class="form-group pt-4">
              <label>Is Active</label>&nbsp;
              <l-switch v-model="formData.is_active">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
              </l-switch>
            </div>
            <div class="form-group pt-4">
              <label>Is Featured</label>&nbsp;
              <l-switch v-model="formData.is_featured">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
              </l-switch>
            </div>
            <div class="form-group pt-4">
              <label>Display in popup</label>&nbsp;
              <l-switch v-model="formData.show_in_popup">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
              </l-switch>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
  import { extend } from "vee-validate";
  import { required, email } from "vee-validate/dist/rules";
  import {Option, Select, Tooltip} from "element-ui";
  import FgSelect from "@/components/Inputs/formGroupSelect";
  import FormGroupTextArea, {ImageUploader, PrimeUploader, PrimeVideoUploader, Switch as LSwitch} from "@/components";
  import Editor from '@tinymce/tinymce-vue'
  import SingleFileUploaderFileManager from "../../../components/FileManager/SingleFileUploaderFileManager";
  import MultipleFileUploaderFileManager from "../../../components/FileManager/MultipleFileUploaderFileManager";

  extend("required", required);
  extend("email", email);

  export default {
    components: {
      MultipleFileUploaderFileManager,
      SingleFileUploaderFileManager,
      FormGroupTextArea,
      [Option.name]: Option,
      [Select.name]: Select,
      [Tooltip.name]: Tooltip,
      FgSelect,
      LSwitch,
      PrimeUploader,
      ImageUploader,
      PrimeVideoUploader,
      'editor': Editor
    },
    props: {
      lang: {
        type: String,
        default: 'en'
      },
      editMode: {
        type: Boolean,
        default: false
      },
      builderData:{},
      formData:{
        type: Object,
        default() {
          return {
            title: "",
            url: "",
            sub_title: "",
            goals: [],
            image: "",
            content: "",
            is_active: true,
            is_featured: false,
            partners: [],
            news: [],
            courses: [],
            content_title: '',
            achievement: '',
            milestones_title: '',
            milestones: [],
            gallery: [],
            gallery_title: '',
            files: [],
            videos: [],
            links: [],
            focus_area_id: "",
            join_extra_sections: [],
            extra_info: '',
            status: '',
            blog_id: '',
            public_comments: [],
            final_report_title: '',
            final_report_date: '',
            final_report_content: '',
            final_report_image: '',
            final_report_link: '',
            final_report_main_title: '',
            final_report_executive_summary: '',
            final_report_keywords: [],
            show_in_popup: false,
          }
        }
      },
    },
    data() {
      return {
        editorConfig: this.getEditorConfig(),
        editorKey: process.env.VUE_APP_TINY_EDITOR_KEY,
        milestoneObject: {
          title: '',
          date: '',
        },
        imagesExtensions: this.getImagesExtensions(),
        pdfExtensions: this.getPdfExtensions(),
        videosExtensions: this.getVideoExtensions(),
      };
    },
    computed: {
      linkedNewsList() {
        try {
          if (!this.formData || !this.formData.news || !this.builderData || !this.builderData.newsList || !Array.isArray(this.formData.news) || !Array.isArray(this.builderData.newsList)) {
            return [];
          }
          return this.builderData.newsList.filter(news => 
            news && news.id && this.formData.news.includes(news.id)
          );
        } catch (error) {
          console.warn('Error in linkedNewsList computed property:', error);
          return [];
        }
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate().then(res => {
          if (res){
            this.$emit('submit-step', this.formData, this.lang)
          }else{
            this.$emit('on-validated', res)
          }
          return res
        });
      },
      generateSomeFields() {
        if(this.editMode){
          return;
        }
        let newUrl = '';
        if (this.formData.title) {
          newUrl = this.formData.title.replace(/\s+/g, "-").toLowerCase();
          newUrl = newUrl.replace(/[^ءأ-يa-zA-Z0-9-]/g, "");
          newUrl = newUrl.replace(/([-]+)/g, "_");
        }

        this.formData.url = newUrl;
      },
      addNewGoal(goals) {
        goals.push('');
      },
      addNewPartner(partner) {
        partner.push({name: '', details: ''});
      },
      removeGoal(goals, index) {
        goals.splice(index, 1);
      },
      addNewMilestone(milestones, listObject){
        milestones.push(listObject);
      },
      removeMilestone(milestones, index) {
        milestones.splice(index, 1);
      },
      addNewItem(listItems, initObject) {
        listItems.push(initObject);
      },
      removeItem(listItems, index) {
        listItems.splice(index, 1);
      },
      addNewPublicComments(item, listObject){
        item.push(listObject);
      },
      removePublicComments(item, index) {
        item.splice(index, 1);
      },
      removeLinkedNews(newsId) {
        try {
          if (this.formData && this.formData.news && Array.isArray(this.formData.news)) {
            const index = this.formData.news.indexOf(newsId);
            if (index > -1) {
              this.formData.news.splice(index, 1);
            }
          }
        } catch (error) {
          console.warn('Error in removeLinkedNews method:', error);
        }
      },
    }
  }
</script>
<style>
.team_list_items{
  border: 1px solid #cccc;
  padding: 10px 45px 30px 19px;
}
.team_list_items .section_name {
  position: relative;
  top: -20px;
  left: 20px;
  background-color: #fff;
  padding: 0 10px;
}

.linked-items-container {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
  background-color: #f9f9f9;
}

.linked-item-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  margin-bottom: 8px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.linked-item-card:last-child {
  margin-bottom: 0;
}

.linked-item-content {
  flex-grow: 1;
}

.linked-item-content h6 {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.linked-item-content small {
  font-size: 12px;
}

.linked-item-actions {
  flex-shrink: 0;
  margin-left: 15px;
}
</style>
